export class ImageConstant {
  static readonly EMPTY_SIGNATURE: string =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=";
  static readonly CUSTOMER_SIGNATURE: string = "CUSTOMER_SIGNATURE";
}
